import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { locales } from './core/constants';
export const localePrefix = 'as-needed'; // removes the locale prefix from the path for default locale (en-US). All other locales will display.

export const { Link, redirect, usePathname, useRouter } =
  createSharedPathnamesNavigation({ locales, localePrefix });
